import { Link } from 'react-router-dom'
import { ArrowRight } from '@/ui/icons'
import type { VehicleProfile } from '@/shared/api/vehicles'
import { getVehicleSubtitle, getVehicleTitle } from '../utils/vehicleLabels'

interface GarageLinkCardProps {
  ownerId: string
  primaryVehicle: VehicleProfile
  vehicleCount: number
}

/** Profile's one pointer to the owner's vehicles. Their details live on Garage. */
export function GarageLinkCard({ ownerId, primaryVehicle, vehicleCount }: GarageLinkCardProps) {
  const detail = [
    getVehicleSubtitle(primaryVehicle),
    vehicleCount > 1 ? `${vehicleCount} vehicles` : null,
  ]
    .filter(Boolean)
    .join(' · ')

  return (
    <Link
      to={`/garage/${ownerId}`}
      className="group block rounded-lg border border-border bg-card p-5 transition-colors hover:bg-earth-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <h2 className="text-base font-semibold text-foreground">Garage</h2>
      <p className="mt-3 break-words text-sm font-medium text-foreground">{getVehicleTitle(primaryVehicle)}</p>
      {detail && <p className="mt-0.5 break-words text-sm text-earth-600">{detail}</p>}
      <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-adventure-600 dark:text-adventure-400">
        View garage
        <ArrowRight className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden />
      </span>
    </Link>
  )
}
